﻿const { Swiper } = require('swiper');
const { Navigation, Autoplay, Thumbs } = require('swiper/modules');

const Gallery = function (el) {
	Swiper.use([Navigation, Autoplay, Thumbs]);

	const swiperThumbs = new Swiper('.landing-gallery-thumbs', {
		spaceBetween: 16,
		slidesPerView: 2.5,
		freeMode: true,
		centeredSlides: true,
		centeredSlidesBounds: true,
		loop: true,
		autoplay: {
			delay: 12000
		},
		breakpoints: {
			// when window width is >= 640px
			640: {
				slidesPerView: 4.5
			},
			// when window width is >= 1100
			1100: {
				slidesPerView: 6.5
			}
		}
	});

	const swiperPreview = new Swiper('.landing-gallery-preview', {
		spaceBetween: 10,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		loop: true,
		thumbs: {
			swiper: swiperThumbs,
		},
	});
};

module.exports = Gallery;